<div id="ot-sdk-cookie-policy"><div id="ot-sdk-cookie-policy-v2" class="ot-sdk-cookie-policy ot-sdk-container" *ngIf="node1 | async as item">
    <h3 id="cookie-policy-title" class="ot-sdk-cookie-policy-title">{{item.title}}</h3>
    <div id="cookie-policy-description">{{item.content}}</div>
    
 